// Leagacy activities
const DOLCH_SPACE = 'DolchSpace';
const FILL_IN_THE_BLANKS = 'FillInTheBlanks';
const HEAR_IT_TYPE_IT = 'HearItTypeIt';
const LEFT_IMAGE_SENTENCES = 'LeftImageSentences';
const MY_CHOICE_KEYBOARDING = 'MyChoiceKeyboarding';
const PUZZLING_LETTERS = 'PuzzlingAnswers';
const RHYME_FLIP = 'RhymeFlip';
const RHYMES_WITH = 'RhymesWith';
const SENTENCES_DOCTOR = 'SentencesDoctor';
const VENN_DIAGRAM = 'VennDiagram';
const WOOD_PIECES = 'WoodPieces';
const WHACK_A_MOLE = 'WhackAMole';

// Assessment accelerator activities
const CONSTRUCT_A_RESPONSE = 'construct-a-response';
const DRAG_AND_DROP_COMPARISON = 'drag-and-drop-comparison';
const DRAG_AND_DROP_CATEGORIES = 'drag-and-drop-categories';
const DRAG_AND_DROP_TABLE = 'drag-and-drop-table';
const DRAG_AND_DROP_BUILD_FRACTIONS = 'drag-and-drop-build-fractions';
const EQUATION_BUILDER = 'equation-builder';
const GRAPH_IT_TABLE = 'graph-it-table';
const GRAPH_IT_IMAGE = 'graph-it-image';
const HIGHLIGHT_IT = 'highlight-it';
const MULTI_SELECT = 'multi-select';
const PICK_THE_ANSWER = 'pick-the-answer';
const SELECT_IT = 'select-it';

const transformers = {
  transformActivity: activity => {
    const { variant } = activity.activityTypeVariant;
    switch (variant) {
      case DOLCH_SPACE:
        return transformers.transformDolchSapce(activity);
      case LEFT_IMAGE_SENTENCES:
        return transformers.transformOptionalTitle(activity);
      case HEAR_IT_TYPE_IT:
        return transformers.transformOptionalImage(activity);
      case PUZZLING_LETTERS:
        return transformers.transformPuzzlingLetters(activity);
      case RHYMES_WITH:
        return transformers.transformRhymesWith(activity);
      case SENTENCES_DOCTOR:
        return transformers.transformSentencesDoctor(activity);
      case VENN_DIAGRAM:
        return transformers.transformVennDiagram(activity);
      case WOOD_PIECES:
        return transformers.transformWoodPieces(activity);
      case WHACK_A_MOLE:
        return transformers.transformOptionalAnswer(activity);
      case CONSTRUCT_A_RESPONSE:
      case DRAG_AND_DROP_COMPARISON:
      case DRAG_AND_DROP_CATEGORIES:
      case DRAG_AND_DROP_TABLE:
      case DRAG_AND_DROP_BUILD_FRACTIONS:
      case EQUATION_BUILDER:
      case HIGHLIGHT_IT:
      case PICK_THE_ANSWER:
        return transformers.transformRoundInstructions(activity);
      case GRAPH_IT_TABLE:
      case GRAPH_IT_IMAGE:
        return transformers.transformGraphIt(activity);
      case FILL_IN_THE_BLANKS:
      case MY_CHOICE_KEYBOARDING:
        return transformers.transformMyChoiceKeyboarding(activity);
      case RHYME_FLIP:
        return transformers.transformOptionalAudio(activity);
      case MULTI_SELECT:
      case SELECT_IT:
        return transformers.transformOptionalImageAndInstructions(activity);
      default:
        return activity;
    }
  },
  transformOptionalImageAndInstructions: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ roundImage, roundInstructions, ...round }) => ({
      ...round,
      image: roundImage,
      instructions: roundInstructions
    }))
  }),
  transformDolchSapce: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ optionalAudio, ...round }) => ({
      ...round,
      audio: optionalAudio
    }))
  }),
  transformMyChoiceKeyboarding: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ steps, ...round }) => ({
      ...round,
      steps: steps.map(({ optionalAudio, optionalImage, optionalQuestion, ...step }) => ({
        ...step,
        audio: optionalAudio,
        image: optionalImage,
        question: optionalQuestion
      }))
    }))
  }),
  transformPuzzlingLetters: ({ imageData, ...data }) => ({
    ...data,
    images: imageData
  }),
  transformRhymesWith: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ steps, ...round }) => ({
      ...round,
      steps: steps.map(({ optionalImg, ...step }) => ({
        ...step,
        img: optionalImg
      }))
    }))
  }),
  transformSentencesDoctor: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ optionalInstructions, optionalImage, ...round }) => ({
      ...round,
      instructions: optionalInstructions,
      image: optionalImage
    }))
  }),
  transformVennDiagram: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ steps, ...round }) => ({
      ...round,
      steps: steps.map(({ vennDiagramPosition, ...step }) => ({
        ...step,
        position: vennDiagramPosition
      }))
    }))
  }),
  transformWoodPieces: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ steps, ...round }) => ({
      ...round,
      steps: steps.map(({ woodPiecesPosition, ...step }) => ({
        ...step,
        position: woodPiecesPosition
      }))
    }))
  }),
  transformGraphIt: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(
      ({ roundInstructions, optionalNumAnswers, optionalMainContent, ...round }) => ({
        ...round,
        instructions: roundInstructions,
        numAnswers: optionalNumAnswers,
        mainContent: optionalMainContent
      })
    )
  }),
  transformRoundInstructions: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ roundInstructions, ...round }) => ({
      ...round,
      instructions: roundInstructions
    }))
  }),
  transformOptionalAnswer: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ steps, ...round }) => ({
      ...round,
      steps: steps.map(({ optionalAnswer, ...step }) => ({
        ...step,
        answer: optionalAnswer
      }))
    }))
  }),
  transformOptionalAudio: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ steps, ...round }) => ({
      ...round,
      steps: steps.map(({ optionalAudio, ...step }) => ({
        ...step,
        audio: optionalAudio
      }))
    }))
  }),
  transformOptionalImage: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ optionalImage, ...round }) => ({
      ...round,
      image: optionalImage
    }))
  }),
  transformOptionalInstructions: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ optionalInstructions, ...round }) => ({
      ...round,
      instructions: optionalInstructions
    }))
  }),
  transformOptionalTitle: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ optionalTitle, ...round }) => ({
      ...round,
      title: optionalTitle
    }))
  })
};

export default transformers;
